import { formatEther } from 'viem';

import { compressString } from '../../utils.js';

const transformers = {
  wallet: (field, d) => compressString(d[field], 4),
  number: (field, d) => Number(d[field]),
  wei: (field, d) => formatEther(d[field]),
  ether: (field, d) => new Intl.NumberFormat('default', { maximumSignificantDigits: 6 }).format(formatEther(d[field]))
}

export default (
  d3, data, conf
  // width, d3, data, donut = true, name, value, nameRepr, valueRepr, colorFunc
) => {
  conf.height = conf.height || Math.min(conf.width);
  // const height = Math.min(width, 500);
  const radius = Math.min(conf.width, conf.height) / 2;

  const arc = d3.arc()
    // .innerRadius(donut ? radius * 0.67 : 0)
    .innerRadius(conf.donut ? radius * 0.55 : 0)
    .outerRadius(conf.donut ? radius - 1 : Math.min(conf.width, conf.height) / 2 - 1);

  const pie = d3.pie()
    .padAngle(1 / radius)
    .sort(null)
    .value(d => transformers[conf.value.type](conf.value.field, d));
    // .value(d => d[conf.value.field]);

  const color = conf.colorFunc || d3.scaleOrdinal()
      .domain(data.map(d => d[conf.key.field]))
      .range(d3.quantize(t => d3.interpolateSpectral(t * 0.8 + 0.1), data.length).reverse());

  const svg = d3.create("svg")
      .attr("width", conf.width)
      .attr("height", conf.height)
      .attr("viewBox", [-conf.width / 2, -conf.height / 2, conf.width, conf.height])
      .attr("style", "max-width: 100%; height: auto;");

  svg.append("g")
    .selectAll().data(pie(data))
    .join("path").attr("fill", d => color(d.data[conf.key.field])).attr("d", arc)
    .append("title").text(d => `${d.data[conf.key.field]}: ${d.data[conf.value.field].toLocaleString()}`);

  const nameRepr = conf.key?.type ?
    (d => transformers[conf.key.repr || conf.key.type](conf.key.field, d.data)) :
    (d => d.data[conf.name.field]);
  const valueRepr = conf.value?.type ?
    (d => transformers[conf.value.repr || conf.value.type](conf.value.field, d.data)) :
    (d => d.data[conf.value.field].toLocaleString());

  svg.append("g")
      .attr("font-family", "sans-serif")
      .attr("font-size", 16)
      .attr("text-anchor", "middle")
    .selectAll()
    .data(pie(data))
    .join("text")
      .attr("transform", d => `translate(${arc.centroid(d)})`)
      .call(text => text.append("tspan")
          .attr("y", "-0.4em")
          .text(nameRepr))
      .call(text => text.filter(d => (d.endAngle - d.startAngle) > 0.25).append("tspan")
          .attr("x", 0)
          .attr("y", "0.7em")
          .attr("font-weight", "bold")
          .attr("font-size", 18)
          .attr("fill-opacity", 0.7)
          .text(valueRepr));

  return svg.node();
}